import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import {
    addActivity,
    editActivity,
    getActivity,
    fetchSchemesOnly
} from '../../../helper/Api';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import {
  FormControl,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const schemeIdToSelectValue = (v) =>
    v != null && v !== "" ? String(v) : "";

const AddActivity = () => {
    const { id } = useParams();
    const { authData } = useSelector((state) => state.authData);
    const [formData, setFormData] = useState({
        status: "1",
        activity: '',
        scheme_id: '',
        created_by: authData.user.id,
    });
    const [schemes, setSchemes] = useState([]);
    const navigate = useNavigate();
    const handleFormData = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData({
            ...formData,
            [name]: value
        });
    }
    const previewHandler = (e) => {
        e.preventDefault();
    };
    const validateForm = (data) => {
        if (!formData.activity) {
            return false;
        }
        return true;
    };
    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const schemesRes = await fetchSchemesOnly();
                if (!cancelled && schemesRes.data.status) {
                    setSchemes(schemesRes.data.schemes);
                }
            } catch (e) {
                if (!cancelled) {
                    toast.error(e.response?.data?.message || "Failed to fetch schemes");
                }
            }
            if (!id) return;
            try {
                const activityRes = await getActivity(id);
                if (!cancelled && activityRes.data.status) {
                    const row = activityRes.data.result[0];
                    const schemeFromApi = row.scheme_id ?? row.schemeId;
                    setFormData({
                        ...row,
                        scheme_id: schemeIdToSelectValue(schemeFromApi),
                        status: row.status != null ? String(row.status) : "1",
                    });
                }
            } catch (e) {
                if (!cancelled) {
                    toast.error(e.response?.data?.message || "Failed to load activity");
                }
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [id]);

    const handleSubmit = async (e) => {
        if (!validateForm()) {
            alert('Activity is required.');
            return;
        }
        try {
            if (id) {
                const response = await editActivity({ activity: formData.activity, status: formData.status, scheme_id: formData.scheme_id || null }, id);
                if (response.data.status) {
                    toast.success(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/department/activity');
                } else {
                    toast.error(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
            else {
                const response = await addActivity({ activity: formData.activity, scheme_id: formData.scheme_id || null });
                if (response.data.status) {
                    toast.success(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/department/activity');
                } else {
                    toast.error(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const linksArray = [
        {
            href: "/department/activity",
            label: "Activities",
        }
    ]

    return (
        <div>
            <div className="p-3">
                <div className="row">
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Add Activity</h4>
                        <CustomBreadcrumbs linksArray={linksArray} title="Add Acitivity"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button
                                type="button"
                                className="submit_button"
                                onClick={handleSubmit}
                                ><span className="fs-14px">Save</span>
                            </button>
                        </div>
                        
                    </div>
                </div>
                <div className="row">
                    <Form onSubmit={previewHandler}>
                        <div className="col-md-12">
                            <div className="card p-3 mt-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id="activity"
                                                        label="Activity Name"
                                                        variant="outlined"
                                                        type="text"
                                                        name="activity"
                                                        value={formData.activity || ""}
                                                        onChange={handleFormData}
                                                        required
                                                    />
                                                </FormControl>
                                            </div>
                                            <div className="col-sm-6">
                                                <FormControl fullWidth variant="outlined">
                                                    <InputLabel id="scheme-label">Scheme (Optional)</InputLabel>
                                                    <Select
                                                        labelId="scheme-label"
                                                        id="scheme_id"
                                                        name="scheme_id"
                                                        value={schemeIdToSelectValue(formData.scheme_id)}
                                                        onChange={handleFormData}
                                                        label="Scheme (Optional)"
                                                    >
                                                        <MenuItem value="">-- None --</MenuItem>
                                                        {schemes.map((scheme) => (
                                                            <MenuItem key={scheme.id} value={String(scheme.id)}>
                                                                {scheme.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>

                                            {id && (
                                                <div className="col-sm-6 mt-3">
                                                    <FormControl fullWidth variant="outlined" required>
                                                        <InputLabel id="activity-status-label">Status</InputLabel>
                                                        <Select
                                                            labelId="activity-status-label"
                                                            id="status"
                                                            name="status"
                                                            value={
                                                                formData.status === "0" || formData.status === "1"
                                                                    ? String(formData.status)
                                                                    : "1"
                                                            }
                                                            onChange={handleFormData}
                                                            label="Status"
                                                        >
                                                            <MenuItem value="1">Active</MenuItem>
                                                            <MenuItem value="0">Inactive</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )

};
export default AddActivity;